/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Field_Message_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Describe what happened and what you expected to happen." |
*
* @param {Support_Field_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_field_message_placeholder = /** @type {((inputs?: Support_Field_Message_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Field_Message_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibe, was passiert ist und was du erwartet hast.")
	return /** @type {LocalizedString} */ ("Describe what happened and what you expected to happen.")
});